export default __webpack_public_path__ + "static/media/goopter-staff-pos-ordering.45318098.jpg";